// Better drag & drop handler that doesn't repeatedly toggle dragleave events
// on every child inside of a drag target.
//
// via http://stackoverflow.com/questions/4942375/how-to-keep-child-elements-from-interfering-with-html5-dragover-and-drop-events
$.fn.dndhover = function (options) {
  return this.each(function () {
    const self = $(this);
    let collection = $();

    self.on('dragenter', (event) => {
      if (collection.size() === 0) {
        self.trigger('dndHoverStart');
      }
      collection = collection.add(event.target);
    });

    self.on('dragleave', (event) => {
      /*
       * Firefox 3.6 fires the dragleave event on the previous element
       * before firing dragenter on the next one so we introduce a delay
       */
      setTimeout(() => {
        collection = collection.not(event.target);
        if (collection.size() === 0) {
          self.trigger('dndHoverEnd');
        }
      }, 1);
    });
  });
};
